import MaterialTable from "@material-table/core";
import React, { useEffect, useState } from "react";
import MatTableHeader from "../../IntMaterialTableHeader/IntMaterialTableHeader";
import { getAllSubmittedQuoetsByForwarders } from "../../api";
import LoaderComponent from "../../../LoaderComponent/LoaderComponent";
import { log } from "../../../Helper";
import SubmittedQuoteDetailsPanel from "../../submittedQuoteDetailsPanel";
import { CustomToolTipEditIcon } from "../../../load-build/utility/tooltip";
import { CustomToolTipDeleteIcon } from "../../../load-build/utility/tooltip";
import InternalSubmittedQuoteDialog from "../Dialog/InternalSubmittedQuoteDialog";
import InternalQuoteDelete from "../Dialog/InternalQuoteDelete";
import { Tooltip } from "@mui/material";
import useFilterState from "../../../hooks/useFilterState";
import _ from "lodash";

const SubmittedQuotesMaterialTable = ({ tableName }) => {
  const [tableData, setTableData] = useState(Array(0));
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(5000);
  const [pageNumber, setPageNumber] = useState(0);
  const [selectedMachinesForQuote, setselectedMachinesForQuote] = useState([]);
  const [selectedMachinesForDeleteQuote, setselectedMachinesForDeleteQuote] =
    useState([]);
  const [preSelectedProvider, setPreSelectedProvider] = useState();
  const [open, setOpen] = React.useState(false);
  const [openQuote, setOpenQuote] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setPreSelectedProvider();
  };

  const handleCloseQuote = () => {
    setOpenQuote(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleOpenQuote = () => {
    setOpenQuote(true);
  };

  const getTableData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllSubmittedQuoetsByForwarders(
        pageNumber,
        pageSize
      );
      log("response for submitted quotes by forwarder in ISMT", response);
      if (!response || !Array.isArray(response)) {
        setTableData([]);
      } else {
        setTableData(response);
      }
    } catch (error) {
      log("Error occured when fetching active quotes: ", error);
      setTableData(Array(0));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTableData();
  }, []);

  const handleQuoteDialogOpen = (data) => {
    log(data);
    setPreSelectedProvider(data.fullProviderList);
    setselectedMachinesForQuote(new Array(data));
    handleOpen();
  };

  const handleDeleteQuoteDialog = (data) => {
    log("Quote Delete data", data);

    const reqObject = {
      deleteQuotedMachineDTOList: data,
    };
    setselectedMachinesForDeleteQuote(new Array(data));
    handleOpenQuote();
  };

  const columns = [
    {
      title: "OrderPath Id",
      field: "orderPathId",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Comar",
      field: "comar",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Pick-Up",
      field: "pickLocation",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Destination",
      field: "shipDestination",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Product",
      field: "productDescription",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "DIM (meter)",
      field: "dimension",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Weight (kg)",
      field: "weight",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Start Date",
      field: "startDate",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Due Date",
      field: "endDate",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Serial",
      field: "serialNumber",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Providers",
      field: "providerList",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
      render: (rowData) => {
        const displayedText = rowData.providerList.slice(0, 7);
        return (
          <Tooltip title={rowData.providerList}>
            <span>{displayedText}..</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Quoted",
      field: "quotedFlag",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "",
      field: "fullProviderList",
      hidden: true,
    },
  ];

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <div className="mt-[-2rem]">
      {isLoading && <LoaderComponent />}
      {!isLoading && (
        <div className="flex flex-col">
          <MatTableHeader getTableData={getTableData} />
          <MaterialTable
            columns={columnsWithFilter.map((col, index) => {
              if (
                col.tableData?.filterValue == "" ||
                col.tableData?.filterValue == null ||
                col.tableData?.filterValue == undefined
              ) {
                let colWithoutDefaultFilter = _.omit(
                  col,
                  "defaultFilter",
                  "tableData.filterValue"
                );
                return colWithoutDefaultFilter;
              } else {
                return {
                  ...col,
                  defaultFilter: col.tableData?.filterValue,
                };
              }
            })}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h6 className="left-[45%] absolute top-[40%] text-center">
                    No records to display
                  </h6>
                ),
              },
              pagination: {
                labelRowsPerPage: "Orders Per Page",
                labelRowsSelect: "Orders",
              },
            }}
            options={{
              rowStyle: {
                fontSize: 10,
              },
              draggable: false,
              selection: false,
              search: false,
              toolbar: false,
              showTitle: false,
              grouping: false,
              pageSize: 100,
              filtering: true,
              maxBodyHeight: 600,
              headerStyle: {
                backgroundColor: "#367c2b",
                fontWeight: "400",
                color: "white",
                position: "sticky",
                top: 0,
                zIndex: 10,
              },
              tableContainerStyle: {
                maxHeight: 600,
                overflow: "auto",
              },
              pageSizeOptions: [100, 500, 1000],
              actionsColumnIndex: -1,
              filterCellStyle: {
                flex: 1,
              },
            }}
            title={"Quote Results"}
            data={tableData}
            onFilterChange={(filters) => {
              // Create a map of current filters for quick lookup
              const filterMap = new Map();
              filters.forEach((filter) => {
                filterMap.set(filter.column.tableData.id, filter.value);
              });

              // Iterate over all columns to ensure each one is checked if the value is present in the filter map
              columnsWithFilter.forEach((col, columnId) => {
                const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

                // Update the filter state for each column
                handleFilterChange(columnId, newValue);
              });
            }}
            actions={[
              (rowData) => ({
                icon: () => <CustomToolTipEditIcon />,
                onClick: (event, rowData) => {
                  handleQuoteDialogOpen(rowData);
                },
              }),
              (rowData) => ({
                icon: () => <CustomToolTipDeleteIcon />,
                onClick: (event, rowData) => {
                  handleDeleteQuoteDialog(rowData);
                },
              }),
            ]}
            detailPanel={({ rowData }) => {
              return (
                <SubmittedQuoteDetailsPanel
                  rowData={rowData}
                  getTableData={getTableData}
                />
              );
            }}
            onRowClick={(event, rowData, togglePanel) => togglePanel()}
          />
          <InternalSubmittedQuoteDialog
            open={open}
            handleClose={handleClose}
            selectedMachineForQuote={selectedMachinesForQuote}
            getTableData={getTableData}
            preSelectedProvider={preSelectedProvider}
          />
          <InternalQuoteDelete
            openQuote={openQuote}
            handleCloseQuote={handleCloseQuote}
            selectedMachinesForDeleteQuote={selectedMachinesForDeleteQuote}
            getTableData={getTableData}
          />
        </div>
      )}
    </div>
  );
};

export default SubmittedQuotesMaterialTable;
